
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, Timer, Zap } from "lucide-react";
import { formatDuration } from "@/lib/utils";
import { WorkspaceAnalytics } from "@/types/workspace";

interface MetricCardProps {
    analytics: WorkspaceAnalytics;
}

export function TimeSavedCard({ analytics }: MetricCardProps) {
    // Calculate totals
    const manualTime = (analytics.manualTimeComparisons || 0) + (analytics.manualTimeSupplements || 0);
    const turboComparisonTime = analytics.aiTimeComparisons || 0;
    const turboSupplementTime = analytics.aiTimeSupplements || 0;
    const totalTurboTime = turboComparisonTime + turboSupplementTime;
    const timeSaved = manualTime - totalTurboTime;

    return (
        <Card className="relative overflow-hidden border-0 bg-gradient-to-br from-purple-500/10 via-white to-purple-600/5 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-full flex flex-col">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/20 to-transparent rounded-full -translate-x-8 -translate-y-8 blur-2xl" />
            <CardHeader className="pb-2 relative">
                <CardTitle className="text-sm font-medium flex items-center gap-2 text-gray-700">
                    <div className="p-2 bg-purple-500/10 rounded-lg">
                        <Clock className="h-4 w-4 text-purple-600" />
                    </div>
                    Total Time Saved
                </CardTitle>
            </CardHeader>
            <CardContent className="relative space-y-2">
                <div className="text-2xl font-bold text-purple-700">
                    {formatDuration(timeSaved)}
                </div>
                <div className="space-y-1 text-xs">
                    <div className="flex justify-between items-center group">
                        <span className="text-gray-500 flex items-center gap-1">
                            <Timer className="h-3 w-3 opacity-50" />
                            Manual time:
                        </span>
                        <span className="font-medium text-gray-700">
                            {formatDuration(manualTime)}
                        </span>
                    </div>
                    <div className="flex justify-between items-center group">
                        <span className="text-gray-500 flex items-center gap-1">
                            <Zap className="h-3 w-3 text-purple-500" />
                            TurboAI time:
                        </span>
                        <span className="font-medium text-purple-600">
                            {formatDuration(totalTurboTime)}
                        </span>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
